export default function TutionReport({ fill, width, height }) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 22"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11357 0C2.28942 0 0 2.28942 0 5.11357V16.8533C0 19.6774 2.28942 21.9669 5.11357 21.9669H12.627C15.4511 21.9669 17.7406 19.6774 17.7406 16.8533V9.06759C17.7406 8.4324 17.5219 7.81658 17.1214 7.3236L12.4239 1.54205C11.6312 0.566454 10.4411 0 9.18406 0H5.11357ZM1.77455 5.11357C1.77455 3.26948 3.26948 1.77455 5.11357 1.77455H8.68738V5.58313C8.68738 7.62924 10.3461 9.28794 12.3922 9.28794H15.966V16.8533C15.966 18.6974 14.4711 20.1923 12.627 20.1923H5.11357C3.26948 20.1923 1.77455 18.6974 1.77455 16.8533V5.11357ZM10.4619 5.58313V2.14305C10.6813 2.28106 10.8794 2.45522 11.0466 2.66107L14.9891 7.51339H12.3922C11.3261 7.51339 10.4619 6.64918 10.4619 5.58313ZM4.17439 10.9202C3.68436 10.9202 3.28711 11.3175 3.28711 11.8075C3.28711 12.2975 3.68436 12.6948 4.17439 12.6948H8.87962C9.36964 12.6948 9.76689 12.2975 9.76689 11.8075C9.76689 11.3175 9.36964 10.9202 8.87962 10.9202H4.17439ZM4.17439 15.2616C3.68436 15.2616 3.28711 15.6589 3.28711 16.1489C3.28711 16.6389 3.68436 17.0362 4.17439 17.0362H12.1574C12.6474 17.0362 13.0447 16.6389 13.0447 16.1489C13.0447 15.6589 12.6474 15.2616 12.1574 15.2616H4.17439Z"
        />
      </svg>
    )
  }
  